// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__10J6p","unreadBadge":"styles_unreadBadge__e23ss","modalContent":"styles_modalContent__1RzqW","modal":"styles_modal__3ahdy"};